import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["href", "icon", "title"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useLocation, useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { StyledButton, StyledListItem } from './nav-item.styles';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Side bar navigation item.
 *
 * @author Ihar Kazlouski
 * @function NavItem
 * @category components
 * @param {string} href navigation path.
 * @param {ReactNode} icon icon component.
 * @param {string} title title.
 * @return {FC} navigation item component.
 */
var NavItem = function NavItem(_ref) {
  var href = _ref.href,
      icon = _ref.icon,
      title = _ref.title,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var location = useLocation();
  var navigate = useNavigate();
  var active = location.pathname === href || "/".concat(location.pathname.split('/')[1]) === href;
  /**
   * Route handler.
   *
   * @author Ihar Kazlouski
   * @param {string} href route.
   * @return {void}
   */

  var handleRoute = function handleRoute(href) {
    return function () {
      navigate(href);
    };
  };

  return /*#__PURE__*/_jsx(StyledListItem, _objectSpread(_objectSpread({
    disableGutters: true
  }, restProps), {}, {
    children: /*#__PURE__*/_jsx(StyledButton, {
      "data-testid": "nav-item-".concat(title, "-button"),
      active: active,
      onClick: handleRoute(href),
      startIcon: icon,
      disableRipple: true,
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "body2",
        fontWeight: active ? 500 : 400,
        children: title
      })
    })
  }));
};

export { NavItem };